
    import '/Users/jilin/projects/antd/rc-dialog/docs/index.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/jilin/projects/antd/rc-dialog/docs/index.md?type=demo')
};